window.versionTracker = {
    getVersion: function () {
        var element = document.getElementsByTagName('body')[0];
        if (!element) return "--";
        return element.getAttribute('data-version');
    }
};